import { Util } from '../_util.js';
import { gsap, ScrollToPlugin,  ScrollTrigger, TimelineMax, MotionPathPlugin } from 'gsap/all';
import { timers } from 'jquery';
import MicroModal from 'micromodal';
import ScrollMagic from '../vendor/scrollmagic/ScrollMagic.js';

const Animations = {

    domeScrollAnimation: function() {
        
            if ($('.js-archAnimation')[0]) {

                let archElParent = '.quotes-slider__content';
                let archEl = '.js-archAnimation';


                // const tl = gsap.timeline({
                //     scrollTrigger: {
                //     trigger: archElParent,
                //     start: 'top center',
                //     end: 'bottom 40%',
                //     //markers: true,
                //     //scrub: 1,
                //     },
                // });
            
                // tl.fromTo(
                //     archEl,
                //     { "bottom": "-68%", "clip-path": "ellipse(37% 50% at 50% 50%)" },
                //     { "bottom": "-39%", ease: 'linear', "clip-path": "ellipse(53% 49% at 50% 50%)" }
                // ).to(
                //     archEl,
                //     { "bottom": "-39%", ease: 'linear', "clip-path": "ellipse(150% 49% at 50% 50%)" }
                // )


                ScrollTrigger.matchMedia({
                    '(min-width:992px)': function() {

                        const tl = gsap.timeline({
                            scrollTrigger: {
                            trigger: archElParent,
                            start: 'top center',
                            end: '40% 40%',
                            //markers: true,
                            scrub: 1,
                            },
                        });
                    
                        tl.fromTo(
                            archEl,
                            { "bottom": "-68%", "clip-path": "ellipse(37% 50% at 50% 50%)" },
                            { "bottom": "-39%", ease: 'linear', "clip-path": "ellipse(53% 49% at 50% 50%)" }
                        ).to(
                            archEl,
                            { "bottom": "-39%", ease: 'linear', "clip-path": "ellipse(150% 49% at 50% 50%)" }
                        )

                        // tl.fromTo(
                        //     archEl,
                        //     { "bottom": "-39%", "clip-path": "ellipse(150% 49% at 50% 50%)" },
                        //     { "bottom": "-39%", ease: 'linear', "clip-path": "ellipse(53% 49% at 50% 50%)" }
                        // ).to(
                        //     archEl,
                        //     { "bottom": "-68%", ease: 'linear',  "clip-path": "ellipse(42% 50% at 50% 50%)" }
                        // )

                    }
                })
     

                
                // gsap.utils.toArray('.js-archAnimation').forEach((archEl) => {
                //     const tl = gsap.timeline({
                //         scrollTrigger: {
                //         trigger: archEl.parentElement,
                //         start: 'top center',
                //         end: '40% 40%',
                //         //markers: true,
                //         scrub: 1,
                //         },
                //     });
                
                //     tl.fromTo(
                //         archEl,
                //         { "bottom": "-68%", "clip-path": "ellipse(37% 50% at 50% 50%)" },
                //         { "bottom": "-39%", ease: 'linear', "clip-path": "ellipse(53% 49% at 50% 50%)" }
                //     ).to(
                //         archEl,
                //         { "bottom": "-39%", ease: 'linear', "clip-path": "ellipse(150% 49% at 50% 50%)" }
                //     )
    
                // });

    
            }
    },
    homeCircleExpand: function() {

                
        if ($('.js-circleExpandAnim')[0]) {

            ScrollTrigger.matchMedia({
                '(min-width:992px)': function() {
        
                gsap.utils.toArray('.js-circleExpandAnim').forEach((circExp) => {
                    const tl = gsap.timeline({
                        scrollTrigger: {
                        trigger: circExp.parentElement,
                        start: 'center 80%',
                        end: '80% 80%',
                        //markers: true,
                        scrub: 1,
                        },
                    });
                
                    tl.fromTo(circExp, {
                        scale: .5
                    }, {
                        scale: 1,
                        duration: .5
                    })

                });

                }
            })


        }

    },
    tileCascadeAnimation: function() {

                
        if ($('.js-tileCascadeAnim')[0]) {

            ScrollTrigger.matchMedia({
                '(min-width:992px)': function() {


                    gsap.set('.js-cascade-tile', {
                        opacity: 0,
                    });

                    ScrollTrigger.batch('.js-cascade-tile', {
                        onEnter: batch => {
                          batch.forEach((card, index) => gsap.to(card, {opacity: 1, y: index * 70, stagger: 0.5, delay: index * 0.3}))
                        },
                        once: true
                      });

                    // gsap.set(".js-cascade-tile", {
                    //     autoAlpha: 0,
                    //     //y: "-=10"
                    //   });
                      
                    //   ScrollTrigger.batch(".js-cascade-tile", {
                    //     onEnter: (elements, triggers) => {
                    //       gsap.to(elements, {
                    //         ease: "ease-out",
                    //         //delay: 0.25,
                    //         autoAlpha: 1,
                    //         stagger: 0.4,
                    //         scrollTrigger: {
                    //           trigger: elements[0].parentElement,
                    //           //scrub: 1,
                    //           markers: true,
                    //           start: 'top 70%',
                    //           end: '70% 70%',
                    //         },
                    //         duration: 0.6,
                    //         // y:function(index){
                    //         //     //console.log(index)
                    //         //     return index * 70;
                    //         //   }
                    //       });
                    //     }
                    //   });

                }
            });
  
            

  

        }

    },
    accordionListExpand() {
        if ($('.js-accordionListExpand')[0]) {


            if ( Util.isMobile() ) {
                $('.accordion-list__item-title').on('click', function() {
              
                    if ( $(this).hasClass('expanded')) {
                        $(this).toggleClass('expanded');
                    } else {
                        $(this).parent().find('.accordion-list__item-title').removeClass('expanded');
                        $(this).toggleClass('expanded');
                    }
                })
            } else {
                $('.accordion-list__item-title').on('click', function() {
                    $(this).toggleClass('expanded');
                })
            }
        }
    },
    collectionAccordionListExpand() {
        if ($('.js-mobileCollectionListExpand')[0]) {

            $('.usage').on('click', function() {
                $(this).toggleClass('expanded');
            })
        }
    },
    productFilterScroll() {
   
            setTimeout(() => {
            if ($('#gf-controls-container')[0]) {

                let ingrePinTl = gsap.timeline({
                    scrollTrigger: {
                        trigger: '#gf-controls-container',
                        start: 'top 9%',
                        end: 'bottom top',
                        endTrigger: '.footer-link-block__content',
                        //markers: true,
                        //pin: true,
                        //pinSpacing: false,
                        toggleClass: 'fixed'
                    },
                });
            

            }
        }, 1000);
    

    },
    collectionFeaturedCards() {

        setTimeout(() => {
        if ($('.featured-advertisement')[0]) {


            const featuredCard = $('.featured-advertisement');
            const globoProducts = $('#gf-products');

            featuredCard.each( function(index) {

                const card = $(this);
                const cardPosition = $(this).attr('card-position');

                //$(this).after("#gf-products:nth-child(" + cardPosition + ")")

                $("#gf-products").append(card);
                // $(this).insertAfter( $("#gf-products:eq(" + (cardPosition - 2 )+ ")"))
                //card.insertAfter( $("#gf-products div:eq(1)"));

                $("#gf-products").children().eq(cardPosition - 2).after(card);
                //console.log(cardPosition - 2);
            });

        }
        }, 2000);


    },
    craftIngredientsToggle: function() {
        if ($('.js-craftToggle')[0]) {

            $('.js-craftToggle .ingredient').on('click', function() {
                const ingredientIndex = $(this).attr('ingredient-index');

                //Button
                $('.js-craftToggle .ingredient').removeClass('active');
                $(this).addClass('active');

                //Ingredient
                $('.craft-ingredient__ingredient').removeClass('active');
                $('.craft-ingredient__ingredient[ingredient-index = "' + ingredientIndex +'"]').addClass('active');
            })

        }
        

    },
    loadMorePressAward: function() {
        if ($('.js-loadMorePress')[0]) {

            $('.js-loadMorePress button').on('click', function() {
                $(this).parent().addClass('hide');
                $('.press-list__links .offset-articles').addClass('loaded-more');
            })
        }
        if ($('.js-loadMoreAward')[0]) {

            $('.js-loadMoreAward button').on('click', function() {
                $(this).parent().addClass('hide');
                $('.award-list__links .offset-articles').addClass('loaded-more');
            })
        }

    },
    fadeIn: function() {

        if ( !Util.isMobile() ) {


        if ($('.js-fadeInHigher')[0]) {
     
            gsap.utils.toArray('.js-fadeInHigher').forEach((fadeIn) => {
                const tl = gsap.timeline({
                    scrollTrigger: {
                    trigger: fadeIn.parentElement,
                    start: '-30% 60%',
                    //markers: true,
                    //toggleActions: "play reverse play reverse"
                    },
                });
            
                tl.fromTo(
                    fadeIn,
                    { opacity: 0 , y: 30 },
                    { ease: 'ease-in', opacity: 1, duration: 1.3, y: 0 }
                );

            });
        }

        if ($('.js-fadeIn')[0]) {
     
            gsap.utils.toArray('.js-fadeIn').forEach((fadeIn) => {
                const tl = gsap.timeline({
                    scrollTrigger: {
                    trigger: fadeIn.parentElement,
                    start: 'top 60%',
                    //markers: true,
                    //toggleActions: "play reverse play reverse"
                    },
                });
            
                tl.fromTo(
                    fadeIn,
                    { opacity: 0 , y: 30, autoAlpha: 0 },
                    { ease: 'ease-in', opacity: 1, autoAlpha: 1, duration: 1.3, y: 0 }
                );

            });
        }

        if ($('.js-selfFadeInHigher')[0]) {


            gsap.utils.toArray('.js-selfFadeInHigher').forEach((selfFadeIn) => {
                const tl = gsap.timeline({
                    scrollTrigger: {
                    trigger: selfFadeIn,
                    start: '-30% 60%',
                    //markers: true,
                    //toggleActions: "play reverse play reverse"

                    },
                });
            
                tl.fromTo(
                    selfFadeIn,
                    { opacity: 0 , y: 30 },
                    { ease: 'ease-in', opacity: 1, duration: 1, y: 0 }
                );

            });

        }

        if ($('.js-selfFadeIn')[0]) {

            gsap.utils.toArray('.js-selfFadeIn').forEach((selfFadeIn) => {
                const tl = gsap.timeline({
                    scrollTrigger: {
                    trigger: selfFadeIn,
                    start: 'top 60%',
                    //markers: true,
                    //toggleActions: "play reverse play reverse"

                    },
                });
            
                tl.fromTo(
                    selfFadeIn,
                    { opacity: 0 , y: 30, autoAlpha: 0 },
                    { ease: 'ease-in', opacity: 1, duration: 1, y: 0, autoAlpha: 1 }
                );

            });
        }
        
        if ($('.js-selfSlowFadeIn')[0]) {

            gsap.utils.toArray('.js-selfSlowFadeIn').forEach((selfSlowFadeIn) => {
                const tl = gsap.timeline({
                    scrollTrigger: {
                    trigger: selfSlowFadeIn,
                    start: 'top 60%',
                    //markers: true
                    },
                });
            
                tl.fromTo(
                    selfSlowFadeIn,
                    { opacity: 0 , y: 30 },
                    { ease: 'ease-in', opacity: 1, duration: 1.5, y: 0 }
                );

            });
   
        }
    }
        

    },
    sideScroller: function() {

                
        if ($('.js-sideScroller')[0]) {

            var professionalCTAController = new ScrollMagic.Controller();

            let ctaRetractTL = new TimelineMax({ paused: true });
            ctaRetractTL.fromTo(
            $('.professionals-tasting-cta'),
            0.5,
            {  autoAlpha: 0, ease: "power1.out" },
            {  autoAlpha: 1, ease: "power2.out" }
            );
        
            ctaRetractTL.play();

            // var scene = new ScrollMagic.Scene({
            // triggerElement: '.collection-products__info',
            // })
            // .on("enter", function (e) {
            // ctaRetractTL.play();
            // })
            // .on("leave", function(e){
            //     ctaRetractTL.reverse();
            // })
            // //.addIndicators({name: "cta trigger"})
            // .addTo(professionalCTAController);


            var scene = new ScrollMagic.Scene({
            triggerElement: "#insta-feed",
            reverse: true
            })
            .on("enter", function (e) {
                ctaRetractTL.reverse();
            })
            .on("leave", function(e){
                ctaRetractTL.play();
            })
            //.addIndicators({name: "cta hide trigger"})
            .addTo(professionalCTAController); 
        }

    },
    init: function() {
        MicroModal.init();

        this.fadeIn();
        this.homeCircleExpand();
        this.tileCascadeAnimation();
        this.domeScrollAnimation();
        this.accordionListExpand();
        this.collectionAccordionListExpand();
        this.productFilterScroll();
        this.collectionFeaturedCards();
        this.craftIngredientsToggle();
        this.loadMorePressAward();
        this.sideScroller();

    },
};

export default Animations;